import { Flex, Typography } from '@banhala/ui-kit';
import { Image, StyleSheet } from 'react-native';
import type { SummaryCardProps } from '../types';

export const SummaryCard = ({ item }: SummaryCardProps) => {
  return (
    <Flex.Row
      padding={{ horizontal: 12 }}
      gap={12}
      alignItems="center"
    >
      <Image
        source={{ uri: item.image }}
        style={styles.thumbnail}
      />
      <Flex.Column gap={4} flexShrink={1}>
        {item.tag && (
          <Flex.Row>
            <Flex.Row
              backgroundColor="lilac5"
              borderRadius="xsmall"
              padding={{ horizontal: 6, vertical: 4 }}
            >
              <Typography type="subtitle5" color="content_blue_primary">
                {item.tag}
              </Typography>
            </Flex.Row>
          </Flex.Row>
        )}
        <Typography
          type="body4"
          color="content_primary"
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {item.name}
        </Typography>
      </Flex.Column>
    </Flex.Row>
  );
};

const styles = StyleSheet.create({
  thumbnail: {
    width: 44,
    height: 44,
    borderRadius: 4,
  },
});
